<template>
    <div>
        <el-breadcrumb separator="/">
            <el-breadcrumb-item>
                <span class="page-title">币安合约</span>
            </el-breadcrumb-item>
            <el-breadcrumb-item>划转统计</el-breadcrumb-item>
        </el-breadcrumb>

        <el-form style="float:left;width: 100%;margin-top: 20px">
            <el-form-item style="display:inline-block;margin-right: 10px">
                <el-input v-model="queryParams.userId" placeholder="用户ID" style="width: 300px"></el-input>
            </el-form-item>
            <el-form-item style="display:inline-block;margin-right: 10px">
                <el-input v-model="queryParams.coinType" placeholder="币种" style="width: 200px"></el-input>
            </el-form-item>
            <el-form-item style="display:inline-block;margin-right: 10px">
                <el-select v-model="queryParams.transferType">
                    <el-option value="" label="全部"></el-option>
                    <el-option value="-1" label="转出"></el-option>
                    <el-option value="1" label="转入"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item style="display:inline-block;margin-right: 10px">
                <el-date-picker
                        v-model="timeArr"
                        type="datetimerange"
                        value-format="timestamp"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                </el-date-picker>
            </el-form-item>
            <el-button type="primary" @click="transferCount">搜 索</el-button>
        </el-form>

        <el-table border :header-cell-style="{background:'#FFF5F4',color:'#EC6D56'}" style="margin-top: 20px"
                  :data="dataList" :row-key="() => Math.random()">
            <el-table-column prop="coinType" label="币种" show-overflow-tooltip></el-table-column>
            <el-table-column prop="type" label="子账户转入/转出" show-overflow-tooltip>
                <template slot-scope="scope">
                    <span v-if="scope.row.type==-1">转出</span>
                    <span v-if="scope.row.type==1">转入</span>
                </template>
            </el-table-column>
            <el-table-column prop="amount" label="数量" show-overflow-tooltip></el-table-column>
        </el-table>

    </div>
</template>

<script>
    import '../store';
    import api from '../api';

    export default {
        name: 'TransferStatistics',
        components: {},
        data() {
            return {
                dataList: [],
                queryParams: {
                    userId: "",
                    coinType: "",
                    transferType: "",
                    transferCreateBeginTime: "",
                    transferCreateEndTime: ""
                },
                timeArr: []
            }
        },
        methods: {
            transferCount() {
                if (this.timeArr != null) {
                    this.queryParams.transferCreateBeginTime = this.timeArr[0];
                    this.queryParams.transferCreateEndTime = this.timeArr[1];
                } else {
                    this.queryParams.transferCreateEndTime == "";
                    this.queryParams.transferCreateBeginTime == ""
                    return;
                }

                if (this.queryParams.transferCreateEndTime == "" || this.queryParams.transferCreateBeginTime == "" || this.queryParams.transferCreateEndTime == undefined || this.queryParams.transferCreateBeginTime == undefined) {
                    this.$message.error('请选择时间范围！');
                    return;
                }
                api.transferCount(this.queryParams).then(({data}) => {
                    this.dataList = data;
                });
            }
        },
        created() {
        }
    };
</script>

<style lang="less" scoped>

</style>

